export const COLLECTION_TRADING_TRADES = 'trades';
